import { MEMBERSHIP_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IMembershipListingResponse, IMembershipListingResponseData } from "@/api_framework/api_modals/Membership";

AxiosCurlirize(axios, () => {});

export const useMembershipDisplayAPI = () => {
  const [membershipDisplay, setMembershipDisplay] = useState<IMembershipListingResponseData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(MEMBERSHIP_MODULE?.MEMBERSHIP_DISPLAY?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IMembershipListingResponse>) => {
          if (res.data.status === true) {
            setMembershipDisplay(res.data.data);
          } else {
            setMembershipDisplay([]);
          }
        })
        .catch((e: AxiosError) => {
          setMembershipDisplay([]);
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      setMembershipDisplay([]);

      if (axios.isAxiosError(error)) {
        captureError(error);
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch, configuration]);

  return { execute, membershipDisplay };
};
